import { Skeleton } from "@/components/ui/skeleton";

type Variant = "marketing" | "auth" | "dashboard";

/**
 * Shared route-level skeleton used as the fallback for lazy-loaded pages.
 * Three variants tuned for the most common public layouts.
 */
export function PageSkeleton({ variant = "marketing" }: { variant?: Variant }) {
  if (variant === "auth") {
    return (
      <div className="flex min-h-screen w-full bg-background">
        <div className="flex w-full flex-col px-6 py-6 md:w-1/2 md:px-12">
          <Skeleton className="h-8 w-32" />
          <div className="mx-auto mt-16 w-full max-w-md space-y-4">
            <Skeleton className="h-9 w-3/4" />
            <Skeleton className="h-4 w-1/2" />
            <Skeleton className="mt-6 h-10 w-full" />
            <Skeleton className="h-10 w-full" />
            <Skeleton className="h-10 w-full" />
          </div>
        </div>
        <aside className="hidden w-1/2 border-l border-border bg-muted/30 md:block">
          <div className="m-auto max-w-md p-12">
            <Skeleton className="h-4 w-24" />
            <Skeleton className="mt-3 h-10 w-full" />
            <Skeleton className="mt-2 h-10 w-3/4" />
          </div>
        </aside>
      </div>
    );
  }
  if (variant === "dashboard") {
    return (
      <div className="container space-y-4 py-8">
        <Skeleton className="h-8 w-1/3" />
        <div className="grid gap-4 md:grid-cols-3">
          <Skeleton className="h-28" />
          <Skeleton className="h-28" />
          <Skeleton className="h-28" />
        </div>
        <Skeleton className="h-64" />
      </div>
    );
  }
  return (
    <div className="container space-y-6 py-12">
      <Skeleton className="h-10 w-2/3" />
      <Skeleton className="h-5 w-1/2" />
      <div className="grid gap-4 md:grid-cols-3">
        <Skeleton className="h-40" />
        <Skeleton className="h-40" />
        <Skeleton className="h-40" />
      </div>
    </div>
  );
}